module.exports = __webpack_public_path__ + "img/blue_072.59409862.png";